module.exports = __webpack_public_path__ + "img/PXioNf1l-EmRPaQ,Chemorozruch_DAkkS-IMS18-0021.bfb14d87.jpeg";